import { useEffect, useRef } from "react";
import {
  useMarkNotificationSeenMutation,
  useUnseenNotificationsQuery,
} from "../queries/notification-queries";

export function useMarkDfyOrderNotificationsSeen(orderExternalId?: string) {
  const { data: unseen = [] } = useUnseenNotificationsQuery();
  const { mutate: markNotificationSeen } = useMarkNotificationSeenMutation();
  // Guards against re-sending while the unseen query is still refetching.
  const markedIdsRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (!orderExternalId) return;

    for (const notification of unseen) {
      if (notification.dfyOrder?.externalId !== orderExternalId) continue;
      if (markedIdsRef.current.has(notification.externalId)) continue;

      markedIdsRef.current.add(notification.externalId);
      markNotificationSeen(notification.externalId);
    }
  }, [unseen, orderExternalId, markNotificationSeen]);
}
